import React from 'react';
import { Wrapper } from './header.styled';
import Logo from '@/assets/game-chess/Logo.png';
function Header() {
  return (
    <Wrapper className='w-[95%] flex items-center justify-between px-[60px] max-w-[1444px] mt-4 mx-4'>
      <div className='flex items-center gap-2'>
        <img src={Logo} className='w-8' alt='' />
        <div className='secondary-font font-normal text-[25px] mt-1 text-[#4E3203] '>
          arcace <span className='secondary-font font-normal text-[25px] text-[#FC2706]'>land</span>
        </div>
      </div>
      <div className='flex items-center gap-4'>
        <div className='font-medium text-[#4E3203] cursor-pointer text-[24px]'>Game list</div>
        <div className='font-medium text-[#4E3203] cursor-pointer text-[24px]'>0x75668....a97d7</div>
      </div>
    </Wrapper>
  );
}

export default Header;
